import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class Utilities_ds_get_first_warehouseService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  public async get($inParams: {  }): 
  Promise<{ result: { Id?: number, Name?: string, Notes?: string, TimeZoneId?: string } }> 
  {
    let $url = `${environment.backendUrl}api/Utilities/datasources/ds_get_first_warehouse/get`;
    
    const $options = {
    }
    
    const $body = null;
    
    return this.$utils.http.post($url, $body, $options);
    
  }


    
    hasMissingRequiredInParams($inParams: { 
      }) {
      return false;
    }
}
